export default __webpack_public_path__ + "static/media/Group 3214@2x.b13a4528.png";